import { useState } from 'react';

/**
 * Custom hook to manage skill projects popup state
 * @returns {Object} - Object containing state and handlers
 */
export const useSkillProjects = () => {
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleSkillClick = (skill) => {
    setSelectedSkill(skill);
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
    setTimeout(() => setSelectedSkill(null), 300); // Clear after animation
  };

  return {
    selectedSkill,
    isPopupVisible,
    handleSkillClick,
    handleClosePopup,
  };
};
